import React from "react";
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle,
    DocumentCardActivity} from '@fluentui/react';
import {ApproverDialog} from "./ApproverDialog";
import { renderDate, renderDateTime } from "../../helpers/HelperMethods";
import Api from '../../services/Api'
import InfoTooltip from '../formFields/InfoTooltip';
import { LocationType } from '../../GlobalConst/globalEnums';

class ApproveSiteTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showApproveDialog: false
        }
    }

    postDecision(approveObject, urlPart)
    {
        const post = {
            id: this.props.site.id,
            ...approveObject
        };

        Api.post(urlPart, post)
            .then(res => res.data)
            .then(post => {
                    if (post === 200) {
                        this.props.refresh();
                    } else {

                        console.log("Update failed")
                    }
                }
            ).catch((error) => {
            console.log(error)})
    }

    onReject = (comment) => {
        const url = '/CreateSiteReject'
        this.postDecision({comment}, url);
    }

    onApprove = (approveObject) => {
        const url = '/CreateSiteApprove';
        this.postDecision(approveObject, url);
    }

    _mapOwnerForPeople(user) {
        return [{
            name: user.displayName
        }];
    }

    render() {
        //let location = this.props.site.farmLocation.address.replace(/\/+$/, '') + '/sites/' + this.props.site.name.substr(0, 90);

        const toolTipContent =
        <span>
                This site includes 10GB of free storage. (Free allocation is subject to future adjustment). If your usage exceeds 10GB, billing applies to the total storage:<br />
                <br />
                - Calculation: You are charged for 45% of Total Storage<br />&emsp;at 0.15 USD per GB/month.<br />
                - Example: A 60GB site costs 4.05 USD/month.<br />&emsp;[45% of 60GB * 0.15 USD = 4.05 USD]<br />
                <br />
                Charges are prorated and billed quarterly to the Admin cost center.<br />
        </span>;

        return (
            <div>
                <DocumentCard styles={cardStyles} >
                    <DocumentCardDetails styles={detailsStyles} >
                        <div style={titleStyles}>
                            <DocumentCardTitle title={"Create site"} shouldTruncate={false} />
                        </div>
                        <div style={statusStyles}>{'Site name: ' + this.props.site.name}</div>
                        <div style={statusStyles}>{'Status: ' + this.props.site.siteStatus}</div>
                        <div style={statusStyles}>{'Cost: ' + this.props.site.farmLocation.cost}{this.props.site.farmLocation.locationType !== LocationType.onPremise ? <span><InfoTooltip content={toolTipContent} /></span> : ""}</div>
                        <div style={statusStyles}>{'Site quota: ' + this.props.site.quotaValue + ' GB'}</div>
                        <div style={statusStyles}>{'Expiration end date: ' + renderDate(this.props.site.expirationDate)}</div>
                        <div style={createdByStyles}>Created by: </div>

                    </DocumentCardDetails>
                    <DocumentCardActivity
                        activity={`Created on ${renderDateTime(this.props.site.created)}`}
                        people={this._mapOwnerForPeople(this.props.site.author)}
                    />
                        <ApproverDialog 
                            buttonName="Decision"
                            reason = {this.props.site.purpose}
                            title="Approve or reject site creation"
                            onReject = {this.onReject}
                            onApprove = {this.onApprove}
                        />
                </DocumentCard>
            </div>
        );
    }
}
// const urlStyles = {
//     root: {
//         color: 'rgb(0, 120, 212)',
//         fontSize: '14px',
//         fontWeight: 'bold'
//     }
// }
const statusStyles = {
    paddingLeft: '12px',
    fontSize: '12px'
}

const createdByStyles = {
    paddingLeft: '16px',
    fontSize: '12px'
}

const titleStyles = {
    maxHeight: '35px'
}

const cardStyles = {
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height: 300,
        border: '1px solid grey',
    }
};

const detailsStyles = {
    root: {
        height: 220
    }
}

export default ApproveSiteTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproveSiteTask.js